module.exports = __webpack_public_path__ + "img/kimmo.f9224b3a.jpeg";